// extracted by mini-css-extract-plugin
export default {"item__icon":"styles_item__icon__NrN6S","item__title":"styles_item__title__Wsu59","item__desc":"styles_item__desc__ySGwG"};